<div *ngIf="hasSelector$ | async" class="flex">
  <span class="flex--self-center ms-xxsmall-r font-body-1 regular-type">{{
    'destinationSearch.originSelectorLabel' | finLocalization
  }}</span>
  <fin-sort-options
    data-testid="destinations-origin-selector"
    [sortOptions]="originOptions$ | async"
    [selected$]="selected$"
    [fieldName]="'sortField'"
    (optionChange)="selectOrigin($event)"
  ></fin-sort-options>
</div>

<p
  *ngIf="(hasSelector$ | async) === false"
  [innerHTML]="'destinationSearch.flightsFrom' | finLocalization: { origin: selectedOriginLocationName$ | async }"
  class="flex--self-center font-body-1 regular-type"
  data-testid="destinations-search-trip-type-origin-label"
></p>
